<script lang="ts">
	import PageGrid from '$lib/storyblok/components/pageGrid.svelte';
	import type { Snippet } from 'svelte';

	interface Props {
		alignment?: 'imageLeft' | 'imageRight';
		grid: Snippet;
		image: Snippet;
		class?: string;
	}

	let { alignment = 'imageLeft', grid, image, class: className }: Props = $props();
</script>

<div
	class="flex flex-col justify-center {className || ''}"
	style="height: calc(100svh - var(--banner-height))"
>
	<PageGrid>
		<div
			class:col-start-3={alignment === 'imageLeft'}
			class:col-end-5={alignment === 'imageLeft'}
			class:col-start-1={alignment === 'imageRight'}
			class:col-end-3={alignment === 'imageRight'}
			class:lg:col-start-8={alignment === 'imageLeft'}
			class:lg:col-end-12={alignment === 'imageLeft'}
			class:lg:col-start-1={alignment === 'imageRight'}
			class:lg:col-end-6={alignment === 'imageRight'}
		>
			{@render grid()}
		</div>
	</PageGrid>
	<div
		style="height: calc(100% - var(--banner-height))"
		class="absolute w-1/2 py-5"
		class:right-0={alignment === 'imageRight'}
		class:pl-5={alignment === 'imageLeft'}
		class:pr-5={alignment === 'imageRight'}
	>
		{@render image()}
	</div>
</div>
